import type { Components, Theme } from '@mui/material';

import { shadows } from '../shadows';

export const MuiButtonGroup: Components<Theme>['MuiButtonGroup'] = {
  styleOverrides: {
    root: {
      boxShadow: shadows[1],
    },
    grouped: ({ theme, ownerState }) => ({
      borderColor: theme.palette.divider,
      // Contained buttons draw their outline via an inset boxShadow, not a real
      // border, so in a group the adjacent inset frames can't merge the way MUI
      // merges real borders (marginLeft -1px) and show up as a doubled line.
      // Only the disabled state has this inset — drop it inside the group so the
      // group's own divider provides a single separator (matching enabled).
      ...(ownerState.variant === 'contained' && {
        '&.Mui-disabled': {
          boxShadow: 'none',
        },
      }),
    }),
  },
};
